declare global {
	interface Window {
		google?: {
			accounts: {
				id: {
					initialize: (config: GoogleIdConfig) => void;
					renderButton: (element: HTMLElement, options: GoogleButtonOptions) => void;
					prompt: () => void;
				};
			};
		};
	}
}

interface GoogleIdConfig {
	client_id: string;
	callback: (response: { credential: string }) => void;
	auto_select?: boolean;
}

interface GoogleButtonOptions {
	theme?: "outline" | "filled_blue" | "filled_black";
	size?: "large" | "medium" | "small";
	width?: number;
	text?: "signin_with" | "signup_with" | "continue_with" | "signin";
}

let scriptLoaded = false;
let hiddenButton: HTMLDivElement | null = null;

function loadGisScript(): Promise<void> {
	if (scriptLoaded) return Promise.resolve();

	return new Promise((resolve, reject) => {
		const script = document.createElement("script");
		script.src = "https://accounts.google.com/gsi/client";
		script.async = true;
		script.defer = true;
		script.onload = () => {
			scriptLoaded = true;
			resolve();
		};
		script.onerror = reject;
		document.head.appendChild(script);
	});
}

export async function initializeGoogleAuth(clientId: string, onCredential: (idToken: string) => void) {
	await loadGisScript();

	window.google?.accounts.id.initialize({
		client_id: clientId,
		callback: (response) => onCredential(response.credential),
	});

	hiddenButton = document.createElement("div");
	hiddenButton.style.position = "absolute";
	hiddenButton.style.opacity = "0";
	hiddenButton.style.pointerEvents = "none";
	hiddenButton.style.width = "0";
	hiddenButton.style.height = "0";
	hiddenButton.style.overflow = "hidden";
	document.body.appendChild(hiddenButton);

	window.google?.accounts.id.renderButton(hiddenButton, {
		theme: "outline",
		size: "large",
		text: "signin_with",
	});
}

export function triggerGoogleSignIn() {
	const button = hiddenButton?.querySelector<HTMLElement>('[role="button"]');
	button?.click();
}

export function promptGoogleOneTap() {
	window.google?.accounts.id.prompt();
}
